import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ProductProvider from './context/Productcontext';
import SidebarProvider from './context/Sidebarcontext';
import CartPorvider from './context/Cartcontext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CartPorvider>
  <SidebarProvider>
  <ProductProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </ProductProvider>
  </SidebarProvider>
  </CartPorvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
